
import ProductThumbnail from './components/ProductThumbnail';

export default {
  i18nComponentKey: 'WidgetProductsProductThumbnail.WidgetProductsProductThumbnailPc',
  name: 'WidgetProductsProductThumbnailPc',
  components: { ProductThumbnail }
};
